/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH2Icon20Solid = forwardRef('SettingsSlidersH2Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 7h6.67a3.001 3.001 0 0 0 5.66 0H17a1 1 0 1 0 0-2h-1.67a3.001 3.001 0 0 0-5.66 0H3a1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M3 13a1 1 0 1 0 0 2h1.67a3.001 3.001 0 0 0 5.66 0H17a1 1 0 0 0 0-2h-6.67a3.001 3.001 0 0 0-5.66 0H3Z" })));
});
